/* Bella kosár-őr: a charm-akció 0 Ft-os ajándék nyaklánca csak akkor maradhat a kosárban,
   ha legalább N (alapból 7) Classic charm van benne – és abból is csak 1 db.
   Fut: oldalbetöltéskor, minden kosármódosító hívás után (Dawn és az EGO/Opus drawer is),
   és fizetésre kattintás előtt (az Opus Shadow DOM-os gombjánál is). */
(() => {
  const me = document.currentScript;
  const GIFT = Number(me && me.dataset.gift);
  const MIN = Number(me && me.dataset.min) || 7;
  if (!GIFT) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let running = null;
  const origFetch = window.fetch;
  let self = false;

  const isCharm = (i) => (i.properties && i.properties._bella_role === 'charm') || i.product_type === 'Charm';

  function check() {
    if (running) return running;
    running = (async () => {
      try {
        const cart = await (await origFetch(`${root}cart.js`, { credentials: 'same-origin' })).json();
        const charms = cart.items.filter(isCharm).reduce((t, i) => t + i.quantity, 0);
        const gifts = cart.items.filter((i) => i.variant_id === GIFT);
        let keep = charms >= MIN ? 1 : 0;
        if (gifts.reduce((t, i) => t + i.quantity, 0) <= keep) return true;
        const updates = {};
        for (const g of gifts) { const q = Math.min(g.quantity, keep); keep -= q; updates[g.key] = q; }
        self = true;
        await origFetch(`${root}cart/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        self = false;
        return false;
      } catch {
        self = false;
        return true;
      } finally {
        setTimeout(() => { running = null; }, 0);
      }
    })();
    return running;
  }

  check().then((ok) => { if (!ok && /\/cart\/?$/.test(location.pathname)) location.reload(); });
  window.BellaCartGuard = { check };

  // Ha valami eltávolította a nyakláncot: az Opus drawert frissítjük, a kosároldalt újratöltjük.
  const after = (ok) => {
    if (ok) return;
    if (typeof window.opusRefreshCart === 'function') { try { window.opusRefreshCart(); } catch {} }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  };
  // Minden /cart/change|update|add hívás után ellenőrzünk (a saját update-ünket kihagyjuk).
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch.apply(this, arguments);
    if (!self && /\/cart\/(change|update|add)(\.js)?/.test(url)) {
      p.then(() => setTimeout(() => check().then(after), 50)).catch(() => {});
    }
    return p;
  };

  // fizetés előtt még egyszer
  const CHECKOUT = '[name="checkout"], a[href*="/checkout"], [class*="checkout" i]:is(button, a)';
  document.addEventListener('click', async (e) => {
    const t = e.composedPath().find((el) => el instanceof Element && el.matches(CHECKOUT));
    if (!t || t.dataset.bbGuarded) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const ok = await check();
    if (!ok) { location.href = `${root}cart`; return; }
    t.dataset.bbGuarded = '1';
    t.click();
    setTimeout(() => { delete t.dataset.bbGuarded; }, 3000);
  }, true);
})();
